<template>
	<div class="card text-left">
		<div class="bg-info card-header text-white">
			<span class="fa fa-search mr-2"></span>
			Búsqueda de anunciantes
		</div>
		<div class="card-body">
			<!-- Buscamos por nombre y por CIF -->
			<div class="row">
				<div class="col-xs-12 col-sm-6 col-md-3 col-lg-3">
					<div class="form-group" v-if="permisos.anunciantes_verTodos">
						<label for="">Agente</label>
						<input type="text" class="form-control input-sm" v-model="filtro.agente" @keypress.enter="buscar" placeholder="Busca por agente">
					</div>
					<div class="form-group" v-if="!permisos.anunciantes_verTodos">
						<label for="">Agente</label>
						<input type="text" class="form-control input-sm" :value="usuario.nombre" disabled>
					</div>

				</div>
				<div class="col-xs-12 col-sm-6 col-md-3 col-lg-3">

					<div class="form-group">
						<label for="">Anunciante</label>
						<input type="text" class="form-control input-sm" v-model="filtro.nombre" @keypress.enter="buscar" placeholder="Busca por nombre">
					</div>

				</div>
				<div class="col-xs-12 col-sm-6 col-md-3 col-lg-3">

					<div class="form-group">
						<label for="">Activo</label>
						<br>
						<div class="btn-group">
							<button class="btn btn-sm" :class="(filtro.activo === null) ? 'btn-primary' : 'btn-default'" @click="filtro.activo = null">Todos</button>
							<button class="btn btn-sm" :class="(filtro.activo === true) ? 'btn-primary' : 'btn-default'" @click="filtro.activo = true">Activo</button>
							<button class="btn btn-sm" :class="(filtro.activo === false) ? 'btn-primary' : 'btn-default'" @click="filtro.activo = false">Inactivo</button>
						</div>
					</div>

				</div>
				<div class="col-xs-12 col-sm-6 col-md-3 col-lg-3">
					<div class="form-group">
						<label for="">Límite de resultados</label>
						<br>
						<div class="btn-group">
							<button class="btn btn-sm" :class="(filtro.max === 50) ? 'btn-primary' : 'btn-default'" @click="filtro.max = 50">50</button>
							<button class="btn btn-sm" :class="(filtro.max === 250) ? 'btn-primary' : 'btn-default'" @click="filtro.max = 250">250</button>
							<button class="btn btn-sm" :class="(filtro.max === 500) ? 'btn-primary' : 'btn-default'" @click="filtro.max = 500">500</button>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="card-footer">
			<button class="btn btn-sm btn-primary" @click="buscar()">
				Buscar
			</button>
			<button class="btn btn-sm btn-warning" @click="nuevo()">
				Nuevo
			</button>
		</div>
	</div>
</template>

<script>

import { mapGetters } from 'vuex'

export default {
	props: ['filtro'],
	data: function () {
		return {
		}
	},
	name: 'filtro-listado',

	computed: {
		...mapGetters({
			usuario: 'session/usuario',
			permisos: 'permisos/permisos'
		})
	},

	methods: {
		buscar () {
			this.$emit('buscar')
		},
		nuevo () {
			this.$emit('nuevo')
		}
	}
}
</script>



// WEBPACK FOOTER //
// src/modulos/gestion-anunciantes/vue/components/listado/listado-filtro.vue